import { useEffect, useRef } from 'react';
import { principles } from '../../../mocks/portfolio';
import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { attachTilt } from '../../../hooks/useTiltCards';
import SectionHeading from '../../../components/base/SectionHeading';

export default function Principles() {
  const revealRef = useScrollReveal<HTMLDivElement>({ stagger: 0.12 });
  const tiltRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!tiltRef.current) return;
    return attachTilt(tiltRef.current, 3);
  }, []);

  return (
    <section
      ref={revealRef}
      className="relative bg-[#050505] text-white py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 tech-grid tech-grid-mask opacity-30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 mb-16">
          <SectionHeading
            eyebrow="Principles 01 — 04"
            title="An operating system for conviction."
            description="The way we work has compounded over a decade — four core principles guide every decision we make."
          />
          <div className="gsap-reveal text-sm font-mono text-white/40 max-w-xs">
            <p>
              Vex is not a fund disguised as a brand. It is an instrument
              designed to deploy patient capital into rare technical bets.
            </p>
          </div>
        </div>

        <div ref={tiltRef} className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5">
          {principles.map((p, idx) => (
            <div
              key={p.title}
              className="gsap-reveal tilt-card group relative bg-[#0a0a0c] p-8 md:p-10 hover:bg-[#0e0e12] transition-colors hover-glow"
            >
              <div className="flex items-start gap-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg liquid-glass shrink-0 tilt-lift">
                  <i className={`${p.icon} text-xl`}></i>
                </div>
                <div>
                  <div className="text-[11px] font-mono uppercase tracking-[0.25em] text-white/30 mb-2">
                    0{idx + 1}
                  </div>
                  <h3 className="font-display text-xl md:text-2xl mb-2 title-shimmer inline-block">
                    {p.title}
                  </h3>
                  <p className="text-white/60 text-sm leading-relaxed">{p.description}</p>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 h-px w-0 bg-white/40 group-hover:w-full transition-all duration-700" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}